var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(!_vm.isPhone)?_c('div',{staticClass:"header-my"},[_c('van-nav-bar',{attrs:{"title":"关于我们"}})],1):_vm._e(),_c('div',{staticClass:"content about"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.companyInfo.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }